export default (node) => {
  const swiperContainer = node.querySelector('[data-swiper-container]');
  const swiperPagination = node.querySelector('[data-swiper-pagination]');
  const autoplayDelay = parseInt(node.dataset.autoplayDelay, 10) || 5000;

  const swiper = new Swiper(swiperContainer, {
    slidesPerView: 1,
    loop: true,
    spaceBetween: 20,
    autoplay: {
      delay: autoplayDelay,
      disableOnInteraction: false,
    },
    breakpoints: {
      768: {
        slidesPerView: 1,
      },
    },
    pagination: {
      el: swiperPagination,
      clickable: true,
      renderBullet: (index, className) => {
        return `<span class="${className} w-2 h-2 mx-1 rounded-full bg-black transition-all"></span>`;
      },
    },
  });
};
